import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";
import { Loader } from "../components/ui/Loader";
import {
  fetchOwnedProject,
  formatArea,
  formatDate,
  formatMoney,
  statusPillClass,
} from "../lib/projects";
import { Project, PROJECT_STATUS_LABELS } from "../models/project";

export const ProjectCard = () => {
  const { id } = useParams<{ id: string }>();
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    fetchOwnedProject(id)
      .then((p) => {
        if (!p) setError("Проєкт не знайдено");
        setProject(p);
      })
      .catch((e) => setError(e instanceof Error ? e.message : "Помилка завантаження"))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <main className="flex-1 px-5 py-8 md:px-8">
      <Link to="/projects" className="link-brand gap-1">
        <LuArrowLeft aria-hidden />
        Мої проєкти
      </Link>

      {loading ? (
        <Loader />
          ) : error ? (
            <p className="mt-6 rounded border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">
              {error}
            </p>
          ) : project ? (
            <section className="card mt-6 max-w-2xl p-6 md:p-8">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <h1 className="text-2xl font-bold text-white">{project.name}</h1>
                  {project.project_code && (
                    <p className="mt-1 text-sm text-neutral-500">{project.project_code}</p>
                  )}
                </div>
                <span
                  className={`rounded-full px-3 py-1 text-xs font-medium ${statusPillClass[project.status]}`}
                >
                  {PROJECT_STATUS_LABELS[project.status]}
                </span>
              </div>

              <dl className="mt-6 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
                <div>
                  <dt className="text-sm text-neutral-500">Передано</dt>
                  <dd className="mt-1 font-semibold text-white">
                    {formatDate(project.submitted_at)}
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-neutral-500">Клієнт</dt>
                  <dd className="mt-1 font-semibold text-white">
                    {project.client_name ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-neutral-500">Телефон клієнта</dt>
                  <dd className="mt-1 font-semibold text-white">
                    {project.client_phone ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-neutral-500">Адреса</dt>
                  <dd className="mt-1 font-semibold text-white">
                    {project.address ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-neutral-500">Площа</dt>
                  <dd className="mt-1 font-semibold text-white">
                    {formatArea(project.area_m2)}
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-neutral-500">Бонус</dt>
                  <dd className="mt-1 font-semibold text-brand">
                    {formatMoney(project.bonus_amount)}
                  </dd>
                </div>
              </dl>

              <div className="md:mt-6 md:border-t md:border-line pt-4">
                <dt className="text-sm text-neutral-500">Коментар Менеджера</dt>
                <dd className="mt-1 text-sm text-neutral-200">
                  {project.manager_comment ?? "—"}
                </dd>
              </div>
            </section>
          ) : null}
    </main>
  );
};
